import * as Sentry from '@sentry/react'

const DSN = import.meta.env.VITE_SENTRY_DSN as string | undefined

export function initSentry(): void {
  if (!DSN) return

  Sentry.init({
    dsn: DSN,
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    environment: import.meta.env.MODE,
  })
}

export function setSentryUser(user: { id: string; email: string } | null): void {
  if (!DSN) return
  Sentry.setUser(user ? { id: user.id, email: user.email } : null)
}

export function captureException(error: unknown): void {
  if (!DSN) return
  Sentry.captureException(error)
}
